const download = require("../download/downloadReducer")

const fetchingPub = (apiUrl, id) => {
  return {
    type: 'FETCHING_PUB',
    payload: { apiUrl, id }
  }
}

const receivePub = (pub) => {
  return {
    type: 'RECEIVE_PUB',
    payload: pub
  }
}

const receivedPub = () => {
  return {
    type: 'RECEIVED_PUB',
  }
}

const showTableOfContents = () => {
  return {
    type: 'SHOW_TOC'
  }
}

const hideTableOfContents = () => {
  return {
    type: 'HIDE_TOC'
  }
}

const toggleFocusMode = () => {
  return {
    type: 'TOGGLE_FOCUS_MODE'
  }
}

const setHeadingPositions = (headings) => {
  return {
    type: 'SET_HEADING_POSITIONS',
    payload: headings
  }
}

const setActiveSection = (id) => {
  return {
    type: 'SET_ACTIVE_SECTION',
    payload: id
  }
}

const setScrollPosition = (position) => {
  return {
    type: 'SET_SCROLL_POSITION',
    payload: position
  }
}

const toggleTableOfContents = () => (dispatch, getState) => {
    let state = getState();
    if(state.reader.tableOfContentsExpanded) {
      dispatch(hideTableOfContents());
    }
    else {
      dispatch(showTableOfContents());
    }
}

const fetchPub = (apiUrl, id, isPreview, lang, callback) => (dispatch, getState) => {
  dispatch(fetchingPub(apiUrl, id, lang));
  var fetchUrl = `${apiUrl}/read/${id}`;
  if (isPreview === 'true') {
      fetchUrl = fetchUrl + '?p=true';
  }
  if (lang != '') {
      var divider = isPreview === 'true' ? "&" : "?";
      fetchUrl = fetchUrl + divider + 'lang=' + lang;
  }
  fetch(fetchUrl, { method: 'GET', credentials: "same-origin" })
    .then(response => response.json())
      .then(data => {
      dispatch(receivePub(data));
      setTimeout(() => {
        dispatch(receivedPub());
        callback();
      }, 600);
  });
}

const toggleDownloadDialog = (downloadFull) => (dispatch, getState) => {
  let state = getState();
  if(state.reader.downloadDialogExpanded) {
    dispatch(hideDownloadDialog());
  }
  else {
    dispatch(showDownloadDialog(!!downloadFull));
  }
}

const showDownloadDialog = (downloadFull) => {
  return {
    type: 'SHOW_PDF',
    payload: downloadFull
  }
}

const hideDownloadDialog = () => {
  return {
    type: 'HIDE_PDF'
  }
}

const initClientSide = () => {
  return {
    type: 'INIT_CLIENTSIDE'
  }
}

module.exports = {
  toggleDownloadDialog,
  fetchPub,
  toggleTableOfContents,
  setScrollPosition,
  setActiveSection,
  setHeadingPositions,
  toggleFocusMode,
  hideTableOfContents,
  receivePub,
  receivedPub,
  initClientSide
}


// WEBPACK FOOTER //
// ./src/modules/reader/readerActions.js